<template>
    <div>
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-2xl font-semibold text-gray-700 dark:text-gray-200">Dashboard</h2>
        
        <div class="flex space-x-2">
          <button class="px-4 py-2 bg-white dark:bg-gray-800 border dark:border-gray-700 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700">
            <span class="flex items-center">
              <svg class="w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
              </svg>
              Filtros
            </span>
          </button>
          
          <button class="px-4 py-2 bg-blue-600 rounded-md shadow-sm text-sm font-medium text-white hover:bg-blue-700">
            <span class="flex items-center">
              <svg class="w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Exportar
            </span>
          </button>
        </div>
      </div>
      
      <!-- Stats row -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        <StatsCard
          title="Total de Avaliações"
          value="1,248"
          change="8.2"
          subtitle="Últimos 30 dias"
          icon-name="chart"
          color="blue"
        />
        
        <StatsCard
          title="NPS Score"
          value="76"
          change="5.3"
          subtitle="Últimos 30 dias"
          icon-name="star"
          color="green"
        />
        
        <StatsCard
          title="Promotores"
          value="864"
          change="12.5"
          subtitle="69.2% do total"
          icon-name="users"
          color="purple"
        />
        
        <StatsCard
          title="Detratores"
          value="124"
          change="-3.8"
          subtitle="9.9% do total"
          icon-name="users"
          color="red"
        />
      </div>
      
      <!-- Charts row -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        <Card title="Tendência NPS">
          <div class="h-80 flex items-center justify-center text-gray-500 dark:text-gray-400">
            <p>Gráfico de linha - Tendência NPS</p>
          </div>
        </Card>
        
        <Card title="Distribuição de Notas">
          <div class="h-80 flex items-center justify-center text-gray-500 dark:text-gray-400">
            <p>Gráfico de barras - Distribuição de Notas</p>
          </div>
        </Card>
      </div>
      
      <!-- Recent feedback -->
      <Card title="Feedbacks Recentes">
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
            <thead class="bg-gray-50 dark:bg-gray-900">
              <tr>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                  Data
                </th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                  Nota
                </th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                  Filial
                </th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                  Comentário
                </th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
              <tr v-for="(feedback, i) in recentFeedbacks" :key="i">
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
                  {{ feedback.date }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span :class="`px-2 py-1 rounded-full text-xs font-medium ${getNpsClass(feedback.score)}`">
                    {{ feedback.score }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
                  {{ feedback.branch }}
                </td>
                <td class="px-6 py-4 text-sm text-gray-700 dark:text-gray-300 max-w-xs truncate">
                  {{ feedback.comment }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <button class="text-blue-600 hover:text-blue-800 dark:hover:text-blue-400 mr-3">
                    Ver
                  </button>
                  <button class="text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200">
                    Responder
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <template #footer>
          <div class="flex items-center justify-between">
            <p class="text-sm text-gray-600 dark:text-gray-400">
              Mostrando 5 de 124 feedbacks
            </p>
            <button class="text-sm text-blue-600 hover:text-blue-800 dark:hover:text-blue-400">
              Ver todos
            </button>
          </div>
        </template>
      </Card>
    </div>
  </template>
  
  <script>
  import { ref } from 'vue';
  import Card from '../ui/Card.vue';
  import StatsCard from '../ui/StatsCard.vue';
  
  export default {
    name: 'DashboardPage',
    components: {
      Card,
      StatsCard
    },
    setup() {
      const recentFeedbacks = ref([
        {
          date: '27/02/2025',
          score: 10,
          branch: 'Matriz - São Paulo',
          comment: 'Excelente atendimento, equipe muito atenciosa e prestativa.'
        },
        {
          date: '26/02/2025',
          score: 9,
          branch: 'Filial - Rio de Janeiro',
          comment: 'Produto com ótima qualidade, recomendo.'
        },
        {
          date: '26/02/2025',
          score: 7,
          branch: 'Filial - Belo Horizonte',
          comment: 'Bom serviço, mas poderia ser mais rápido.'
        },
        {
          date: '25/02/2025',
          score: 3,
          branch: 'Matriz - São Paulo',
          comment: 'Problemas com o atendimento, demorou muito para resolver minha questão.'
        },
        {
          date: '24/02/2025',
          score: 10,
          branch: 'Filial - Brasília',
          comment: 'Superou todas as expectativas, excelente experiência!'
        }
      ]);
      
      const getNpsClass = (score) => {
        if (score >= 9) return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200';
        if (score >= 7) return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200';
        return 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200';
      };
      
      return {
        recentFeedbacks,
        getNpsClass
      };
    }
  };
  </script>